/**
 * Rich task comments (card 7de79076): the pure helpers.
 *
 * A rich comment keeps BOTH fields:
 *  - `bodyHtml` — the editor's sanitized HTML (formatting, images as
 *    encrypted-attachment references, never bytes);
 *  - `body` — its plain text, which everything that is not the task window
 *    keeps reading: @-mention resolution, notifications, search, the MCP
 *    board tools, chat shares and older app versions.
 */

const PENDING_RE = /data-pending-ref=/i;

/** The plain text of comment HTML, with block breaks as newlines. */
export function commentPlainText(html) {
  const s = String(html || '');
  if (!s) return '';
  return s
    .replace(/<\s*br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|h[1-6]|li|blockquote|pre)>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

/** True while an image/video in the draft is still uploading. */
export function commentHasPendingMedia(html) {
  return PENDING_RE.test(String(html || ''));
}

/**
 * Is the HTML more than its plain text — formatting, a list, a link, media?
 * A comment that is just words is stored as `body` alone, exactly as before.
 */
export function commentNeedsHtml(html) {
  const s = String(html || '').trim();
  if (!s) return false;
  const stripped = s.replace(/<\/?(p|br|span)(\s[^>]*)?>/gi, '');
  return /<[a-z]/i.test(stripped);
}
